import { Pipe, PipeTransform } from '@angular/core';

interface VendorFilterItem {
  Name: string;
}

@Pipe({
  name: 'vendorFilter',
  standalone: false,
})
export class VendorFilterPipe implements PipeTransform {
  transform(
    value: VendorFilterItem[] | undefined,
    args: string
  ): VendorFilterItem[] | undefined {
    if (!args) return value;
    const filter = args.toLocaleLowerCase();
    return filter
      ? value.filter(
          (vendor) => vendor.Name.toLocaleLowerCase().indexOf(filter) !== -1
        )
      : value;
  }
}
